import React, { useContext, useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { TenantIdContext } from '../../../../components/app/App';
import { batchUploadTerminology } from '../../services/api-calls';
import Button from '@amzn/meridian/button';
import Alert from '@amzn/meridian/alert';
import Text from '@amzn/meridian/text';

const CsvUpload = () => {
  const tenantId = useContext(TenantIdContext);
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState([]);
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleFileChange = e => {
    const selected = e.target.files[0];
    if (!selected) return;
    setFile(selected);
    setResult(null);
    const reader = new FileReader();
    reader.onload = event => {
      const lines = event.target.result.split(/\r?\n/).filter(l => l.trim());
      setPreview(lines.slice(0, 11));
    };
    reader.onerror = () => {
      setFile(null);
      setPreview([]);
      setResult({ error: 'Failed to read file' });
    };
    reader.readAsText(selected);
  };

  const handleUpload = async () => {
    if (!file || !tenantId) return;
    setLoading(true);
    try {
      const response = await batchUploadTerminology({ tenantId, file });
      setResult(response.data);
    } catch (err) {
      setResult({ error: err.message || 'Upload failed' });
    }
    setLoading(false);
  };

  return (
    <Container fluid className="p-3">
      <Row className="mb-3">
        <Col>
          <Text type="h100">Batch Upload Terminology (CSV)</Text>
        </Col>
      </Row>
      <Row className="mb-2">
        <Col>
          <Text type="b200">CSV columns: sourceTerm, targetTerm, sourceLocale, targetLocale</Text>
        </Col>
      </Row>
      <Row className="mb-3">
        <Col>
          <input type="file" accept=".csv" onChange={handleFileChange} />
        </Col>
      </Row>
      {preview.length > 0 && (
        <Row className="mb-3">
          <Col>
            <Text type="h200">Preview ({Math.min(preview.length - 1, 10)} rows)</Text>
            <pre style={{ fontSize: 12, maxHeight: 200, overflow: 'auto', background: '#f5f5f5', padding: 8 }}>
              {preview.join('\n')}
            </pre>
          </Col>
        </Row>
      )}
      {file && (
        <Row className="mb-3">
          <Col>
            <Button type="primary" onClick={handleUpload} disabled={loading}>
              {loading ? 'Uploading...' : `Upload to ${tenantId}`}
            </Button>
          </Col>
        </Row>
      )}
      {result && !result.error && (
        <Row>
          <Col>
            <Alert type="success">
              Loaded {result.loaded} entries.{result.errors?.length > 0 && ` ${result.errors.length} errors.`}
            </Alert>
          </Col>
        </Row>
      )}
      {result?.error && (
        <Row>
          <Col>
            <Alert type="error">{result.error}</Alert>
          </Col>
        </Row>
      )}
    </Container>
  );
};

export default CsvUpload;
